import { schema } from 'normalizr';

export const cosAnnexeSchema = new schema.Entity('cosAnnexes', {}, { idAttribute: 'CosAnnexeId' });

export const cosAnnexeListSchema = [cosAnnexeSchema];
